export default "__VITE_ASSET__2854ecca__"